import { useState } from "react";
import { Modal } from "../Modal";
import {
    CreateDepartmentModalContainer,
    CreateDepartmentModalContentContainer,
    CreateDepartmentModalTitle,
    CreateDepartmentModalContentWrapper,
    Form,
    Button,
    Input,
} from "./CreateDepartmentModal.styles";

// Language Context
import { useLanguage } from "../../../core/translations/LanguageContext";

// Translations
import { CreateDepartmentModalTranslations } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import { SupportedLanguage } from "../../../core/translations/supportedLanguages";

const TRANSLATIONS: Record<
    SupportedLanguage,
    CreateDepartmentModalTranslations
> = {
    en: enTranslations,
    de: deTranslations,
};
interface CreateDepartmentModalProps {
    onRequestClose: () => void;
    onSubmit: (e: any) => void;
    setFormData: (e: any) => void;
    formData: {
        name: string;
    };
}
const CreateDepartmentModal = ({
    onRequestClose,
    onSubmit,
    setFormData,
    formData,
}: CreateDepartmentModalProps) => {
    const { language } = useLanguage();
    //@ts-ignore
    const translations = TRANSLATIONS[language];
    return (
        <Modal onRequestClose={onRequestClose}>
            <CreateDepartmentModalContainer>
                <CreateDepartmentModalContentContainer>
                    <CreateDepartmentModalContentWrapper>
                        <Form>
                            <CreateDepartmentModalTitle>
                                {translations.title}
                            </CreateDepartmentModalTitle>
                            <Input
                                name="institute_name"
                                //@ts-ignore
                                onChange={(e) =>
                                    setFormData({ name: e.target.value })
                                }
                                value={formData?.name}
                            />

                            <Button
                                backgroundColorHex="#102c46"
                                onClick={(e) => onSubmit(e)}
                            >
                                {translations.createButtonText}
                            </Button>
                        </Form>
                    </CreateDepartmentModalContentWrapper>
                </CreateDepartmentModalContentContainer>
            </CreateDepartmentModalContainer>
        </Modal>
    );
};

export default CreateDepartmentModal;
